import { Button, Modal, Text } from '@driftt/dds'
import React from 'react'

const ConfirmationModal = ({
  isOpen,
  onClose,
  onAction,
  action = '',
  loading = false,
}: {
  isOpen: boolean
  onClose?: () => void
  onAction?: () => void
  action: string
  loading?: boolean
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const ARCHIVE_TITLE = 'Archive guardrail?'
  const ARCHIVE_CONTENT =
    'Are you sure you want to archive this guardrail? You can always restore it later.'

  const RESTORE_TITLE = 'Restore guardrail?'
  const RESTORE_CONTENT =
    'Are you sure you want to restore this guardrail? You can always archive it later.'

  return (
    <Modal.Root open={isOpen} onClose={handleClose}>
      <Modal.Dialog size="small" variant="warning">
        <Modal.Title
          title={action === 'archive' ? ARCHIVE_TITLE : RESTORE_TITLE}
        />
        <Modal.Content>
          <Text>
            {action === 'archive' ? ARCHIVE_CONTENT : RESTORE_CONTENT}
          </Text>
        </Modal.Content>
        <Modal.Actions>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onAction} loading={loading}>
            {'Continue'}
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default ConfirmationModal
